import { render, staticRenderFns } from "./MultiItem.vue?vue&type=template&id=3abab449&"
import script from "./MultiItem.vue?vue&type=script&lang=js&"
export * from "./MultiItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports